<div class="vehicle container-fluid">
    <div class="row">
        <div class="vehicle-title col-md-10">
            <label>Vehicle Model & Year Management Portal</label>
        </div>
        <div class="col-md-2" *ngIf="hasPermission">
            <button type="button" routerLink="/admin/addVehicle" class="btn btn-default addmodel">Add Vehicle Model
            </button>
        </div>

    </div>

    <div class="row">
        <div class="col-md-12 mt-2">
            <div class="row manage-vehicle-header">

                <div class="col-md-2 model-header-align">Model

                </div>
                <div class="col-md-1 year-header-align">Year

                </div>
                <div class="col-md-1 generation-header-align">Generation

                </div>
                <div class="col-md-3 generation-header-align">Internal

                </div>
                <div class="col-md-3 features-header-align">External

                </div>



            </div>
            <div class="row" *ngFor="let alert of alerts" class="padding-b-15">
                <div class="alert alert-dismissible" [ngClass]="{'alert-danger': alert.type === 'error','alert-success': alert.type === 'success'}">
                    <button type="button" class="close" data-dismiss="alert" (click)="closeAlerts()">×</button>
                    {{ alert.msg }}
                </div>
            </div>
        </div>
    </div>

    <div class=row>
        <div class="col-md-12 ">
            <div class="vehicle-tile ">
                <div *ngFor="let vehicle of vehicleModels">
                    <!-- <div *ngFor="let year of vehicle.years "> -->
                    <span class="card ">
                        <div class="card-block ">
                            <div class="card-body text-center ">
                                <div class="row col-md-12 ">
                                    <div class="col-md-2 ">
                                        {{vehicle.model}}
                                    </div>
                                    <div class="col-md-1">
                                        {{vehicle.year}}
                                    </div>
                                    <div class="col-md-1">
                                        {{vehicle.generation}}
                                    </div>
                                    <div class="col-md-3 features-list">
                                        <div *ngFor="let internal of vehicle.internal; let i=index ">
                                            {{internal}}
                                        </div>
                                    </div>
                                    <div class="col-md-3 features-list">
                                        <div *ngFor="let external of vehicle.external; let i=index ">
                                            {{external}}
                                        </div>
                                    </div>
                                    <span class="action-control col-md-2 ">
                                        <a class="action-control-edit " (click)="editVehicle(vehicle,vehicle.year) ">
                                            <img alt="Edit" [src]="commonService.commonFiles['edit']">
                                        </a>
                                        <a *ngIf="hasPermission" class="action-control-delete " (click)="deleteVehicle(vehicle,vehicle.year) ">
                                            <img alt="Delete" [src]="commonService.commonFiles['delete']">
                                        </a>
                                    </span>
                                </div>

                            </div>
                        </div>
                    </span>
                </div>
                <!-- </div> -->
            </div>
        </div>
    </div>
</div>